import { useState } from 'react'

import { HubspotFormEmbed } from 'src/components/atoms/HubspotFormEmbed'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

type HubspotContactFormProps = {
  formId: string
  title: string
  intro?: string
}

const HubspotContactForm = ({
  formId,
  title,
  intro
}: HubspotContactFormProps) => {
  const [formSubmitted, setFormSubmitted] = useState(false)

  return (
    <div>
      <TypographyRebrand variant='h2' color='forestDeep'>
        <strong>{title}</strong>
      </TypographyRebrand>
      {!formSubmitted && intro && (
        <TypographyRebrand variant='introduction' color='forestDeep'>
          {intro}
        </TypographyRebrand>
      )}
      <HubspotFormEmbed
        formId={formId}
        onFormSubmit={() => setFormSubmitted(true)}
      />
    </div>
  )
}

export default HubspotContactForm
